export const capitalize = (string?: string) =>
	typeof string === "string" ? string.charAt(0).toLocaleUpperCase() + string.substring(1) : "";
